import { Controller } from "@hotwired/stimulus";

// Copies a value to the clipboard and briefly confirms on the button, so an admin
// can paste a mobile app link straight into a support reply without selecting text.
export default class extends Controller {
  static values = { text: String };
  static targets = ["button"];

  async copy() {
    await navigator.clipboard.writeText(this.textValue);
    if (!this.hasButtonTarget) return;

    const button = this.buttonTarget;
    const original = button.textContent;
    button.textContent = "Copied";
    setTimeout(() => {
      button.textContent = original;
    }, 1500);
  }
}
